<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <h1 v-translate>Přidat odběratele</h1>
      </div>
      <div class="responsiveTabs">
        <ul class="tabs">
          <li :class="getActiveTabClass('settings')">
            <a @click="activateTab('settings')" v-translate>Vlastnosti</a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('settings')">
          <section v-show="$_createActionAllowedAll">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                  v-model="operatorIdComputed"
                  :options="operatorOptions"
                  :required="true"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <h2 v-translate>Základní údaje</h2>
            </div>
          <basic-info
              :entity="entity"
              :operator-options="operatorOptions"
              ref="basicinforef"
              :is-editable="true"
          />
          </section>
          <contact
              :subscriber="entity"
              ref="contactref"
              :is-editable="true"
          />
          <settings :subscriber="entity"
                    :subjectTypeOptions="subjectTypes"
                    :subscriberTypeOptions="subscriberTypes"
                    :operatorsMaximumPairedDeviceCount="entity.maximum_paired_device_count"
                    :maxOperatorsDeviceCount="maxOperatorsDeviceCount"
                    ref="settingsref"
                    @set-password="setNewPassword"
                    :is-editable="true"
          />
          <section class="buttons">
            <p>
              <router-link
                  :to="{ name: moduleName }"
                  class="btn btn_back btn_seznam"
                  v-translate>Seznam
              </router-link>
              <input
                  type="submit"
                  :value="'Uložit vlastnosti' | translate"
                  :class="['btn', { btn_inactive: !formIsValid }]"
                  @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BasicInfo from "@/components/views/subscribers/settings/BasicInfo"
import Contact from "@/components/views/subscribers/settings/Contact"
import Settings from "@/components/views/subscribers/settings/Settings"
import detailActions from "@/components/mixins/detail-actions"
import subscriberData from "@/components/mixins/subscriber-data"
import subscribers from "@/components/views/subscribers/mixins/subscribers"

export default {
  name: "SubscriberNew",
  components: {
    BasicInfo,
    Contact,
    Settings
  },
  mixins: [detailActions, subscriberData, subscribers],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      maxOperatorsDeviceCount: 0,
      entity: {
        id_type: null,
        subject_type: 'person',
        parental_lock_pin: null,
        maximum_paired_device_count: null,
        login: null,
        password: null,
        id_operator: null,
        tag_ids: []
      },
    }
  },
  created(SubscriberService, OperatorService) {
    this.entityService = SubscriberService
    this.operatorService = OperatorService
    this.getOperatorsAndSetIdOperatorToEntity()
      .then(() => {
        this.getSubscriberTypeList(this.entity.id_operator)
      })
  },
  watch: {
    operatorIdComputed: {
      handler(newVal, oldVal) {
        if (Number(oldVal) !== Number(newVal)) {
          this.entity.tag_ids = [];
          this.operatorService.getOperatorConfiguration(newVal)
              .then(data => {
                let operatorConfig = data['operator_configuration']
                this.entity.id_type = operatorConfig['default_subscriber_type_id']
                this.entity.maximum_paired_device_count = operatorConfig['default_subscriber_max_paired_device_count']
                this.maxOperatorsDeviceCount = operatorConfig['subscriber_max_paired_device_count']
              })
        }
      },
      deep: true,
    }
  },
  computed: {
    operatorIdComputed: {
      get() {
        return this.entity.id_operator
      },
      set(newValue) {
        this.entity.id_operator = newValue
      }
    }
  },
  methods: {
    createEntity(redirect = false) {
      this.entityService.createEntity(this.filterFormParams({...this.entity}))
          .then(data => {
            this.saveLastVisited(data.id)
            if (redirect === true) {
              this.$router.push({name: this.moduleName})
            } else {
              this.$router.push({name: this.detailPageRouteName, params: {id: data.id}})
            }
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error))
          }.bind(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/SubscriberNew.vue